import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
import * as yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { FormError } from '~/components/form/FormError';
import { PresetAutocomplete } from '../PresetAutocomplete';
const formSchema = yup
    .object({
    psychosocialName: yup.string().required('Psychosocial name is required'),
    psychosocialDescription: yup.string().nullable()
})
    .required();
export const AddPsychosocialModal = (props) => {
    const { onRequestClose, itemToEdit, patientId, onSuccess } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            psychosocialName: itemToEdit ? itemToEdit.psychosocialName : '',
            psychosocialDescription: itemToEdit ? itemToEdit.psychosocialDescription : ''
        },
    });
    const { formState: { errors }, handleSubmit, register, } = methods;
    const onFormSubmit = async ({ psychosocialName, psychosocialDescription }) => {
        setIsSubmitting(true);
        console.log('submitting');
        const data = {
            psychosocialName: psychosocialName == '' ? null : psychosocialName,
            psychosocialDescription: psychosocialDescription == '' ? null : psychosocialDescription
        };
        console.log(data);
        if (itemToEdit) {
            const response = await axios.post('/api/carePlan/editPsychosocial', {
                psychosocialId: itemToEdit.id,
                psychosocialName: data.psychosocialName,
                psychosocialDescription: data.psychosocialDescription
            });
            const new_psychosocial = response.data.data.new_psychosocial;
            const updatedPsychosocial = {
                id: new_psychosocial.id,
                patientId: new_psychosocial.patient_id,
                carePlanId: new_psychosocial.care_plan_id,
                psychosocialName: new_psychosocial.psychosocial_name,
                psychosocialDescription: new_psychosocial.psychosocial_description,
                updatedAt: new Date(new_psychosocial.updated_at),
                deletedAt: new Date(new_psychosocial.deleted_at),
                createdAt: new Date(new_psychosocial.created_at),
                isEditable: new_psychosocial.is_editable,
                month: new_psychosocial.month
            };
            onSuccess(updatedPsychosocial);
        }
        else {
            const response = await axios.post('/api/carePlan/addPsychosocial', {
                patientId: patientId,
                psychosocialName: data.psychosocialName,
                psychosocialDescription: data.psychosocialDescription
            });
            const new_psychosocial = response.data.data.new_psychosocial;
            const updatedPsychosocial = {
                id: new_psychosocial.id,
                patientId: new_psychosocial.patient_id,
                carePlanId: new_psychosocial.care_plan_id,
                psychosocialName: new_psychosocial.psychosocial_name,
                psychosocialDescription: new_psychosocial.psychosocial_description,
                updatedAt: new Date(new_psychosocial.updated_at),
                deletedAt: new Date(new_psychosocial.deleted_at),
                createdAt: new Date(new_psychosocial.created_at),
                isEditable: new_psychosocial.is_editable,
                month: new_psychosocial.month
            };
            onSuccess(updatedPsychosocial);
        }
        setIsSubmitting(false);
    };
    return (React.createElement(Dialog, { open: true, PaperProps: {
            sx: { maxHeight: '60vh', maxWidth: '50%', width: '50%' }
        } },
        React.createElement(DialogTitle, { sx: {
                m: 0, p: 2, display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }, id: "customized-dialog-title" },
            itemToEdit ? 'Edit Psychosocial Need' : 'Add Psychosocial Need',
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5", style: { marginLeft: 'auto', marginRight: 'auto', width: '70%' } },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Psychosocial Need"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "psychosocialName", presets: props.presets, category: "psychosocial", field: "psychosocial", placeholder: "e.g., Reports mild anxiety about glucose fluctuations" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Description/Notes"),
                                React.createElement("div", { className: "row" },
                                    React.createElement("textarea", { className: 'problem-list-scroll', onKeyDown: (event) => event.stopPropagation(), style: {
                                            fontFamily: 'Barlow',
                                            verticalAlign: 'top',
                                            overflowY: 'scroll',
                                            height: '85px',
                                            padding: '10px',
                                            width: '100%',
                                            borderWidth: '1px',
                                            borderColor: '#B9B9B9',
                                            borderRadius: '4px'
                                        }, placeholder: 'Enter Notes', ...register('psychosocialDescription'), defaultValue: itemToEdit?.psychosocialDescription ?? '' })),
                                React.createElement(FormError, { errors: errors, name: "add-problem" })))),
                    React.createElement("div", { className: "flex justify-between items-center" },
                        React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: isSubmitting, type: "submit", color: "primary" }, itemToEdit ? 'Edit Psychosocial Need' : 'Add Psychosocial Need')))))));
};
